import { findIndex } from 'lodash';
import { UndoAction } from './Action';
import { CHANGE_ITEM } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */

class ChangeItemAction extends UndoAction {
  constructor(options) {
    super(options);

    this.itemListName = options.itemListName;
    this.index = options.index;
    this.item = options.item;
    this.value = options.value;
    this.origDescription = this.item.description.slice();
  }

  static get name() { return 'ChangeItemAction'; }

  _executeImpl() {
    const self = this;

    return this.component.$apollo.mutate({
      mutation: CHANGE_ITEM,
      variables: {
        id: this.component.shoppingList.id,
        itemId: this.item.id,
        newDescription: this.value,
        itemListName: this.itemListName,
      },
      update(store, { data: { shoppingListChangeItem } }) {
        self._updateCache(store, shoppingListChangeItem);
      },
      optimisticResponse() {
        const shoppingListChangeItem = {
          __typename: 'ShoppingListChangeItemResult',
          item: {
            ...self.item,
          },
          modifiedAt: null,
        };

        shoppingListChangeItem.item.description = self.value;
        return { shoppingListChangeItem };
      },
    });
  }

  updateQuery(cachedShoppingList, shoppingListChangeItem) {
    cachedShoppingList.items[this.itemListName][this.index] =
      shoppingListChangeItem.item;
    return cachedShoppingList;
  }

  undo() {
    const currentList = this.component.shoppingList.items[this.itemListName];
    const index = findIndex(currentList, { id: this.item.id });
    if (index < 0) {
      throw new Error('Change item undo failed, item not found.');
    }

    return this.component.triggerAction(ChangeItemAction, {
      itemListName: this.itemListName,
      index,
      item: currentList[index],
      value: this.origDescription,
      undoAction: this,
    });
  }

  updateItem(oldItem, newItem) {
    if (this.item.id === oldItem.id) {
      this.item = newItem;
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo change item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo change item'; }
}

export default ChangeItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/ChangeItemAction.js